/* eslint-disable no-console */
import('./bootstrap').catch((err) => console.error(err));
